// src/themes/system-b.js
//
// SISTEMA B — Taxonomía operativa invariante entre temas.
//
// Los 21 tokens de este archivo se aplican IDÉNTICOS en los 3 temas
// (Desaturado, Vibrante, Tactical). Un operador que cambia de tema NO
// debe perder su mapa mental cromático: una patrulla es azul en los 3
// temas, un incidente es rojo en los 3, un bus es verde en los 3.
//
// Calibración OKLCH:
//   - L entre 55-76 (visible sobre los 3 bgs, no fatigante)
//   - C entre 0.08-0.22 según función (entity moderado, alert alto)
//   - Hues equidistantes dentro de cada grupo (distancia perceptual máxima)
//   - Pares CVD-críticos (rojo/verde) separados también por L
//
// Este archivo se mergea en apply.js antes de emitir CSS vars, de modo
// que los consumidores siguen leyendo `--kln-entity-blue`, `--kln-alert-sos`,
// etc. sin cambios en su código.

export default {
  // ========== ENTITY (7 slots de identificación de tipo) ==========

  entityBlue:   '#4687D4',  // L62 C0.15 H248 — policía (todas las corporaciones)
  entityTeal:   '#3DA0B8',  // L62 C0.12 H205 — cámaras, LPR, external_sensor
  entityGreen:  '#38926A',  // L55 C0.14 H155 — transporte + salud fija
  entityGold:   '#D3B246',  // L76 C0.13 H92  — GN, militar
  entityOrange: '#E29248',  // L70 C0.14 H52  — emergencia física
  entityRed:    '#DB5948',  // L62 C0.18 H22  — sensor pánico, incident ACTIVO
  entityViolet: '#A87DD0',  // L62 C0.15 H295 — reservado (no asignado)

  // ========== STATUS (4 estados operacionales) ==========

  statusOnline:  '#4C8370',  // L55 C0.08 H150 — operativo normal
  statusOffline: '#8D3A2E',  // L44 C0.12 H26  — sin reporte
  statusAlert:   '#CA8E38',  // L68 C0.16 H72  — atención (bus alert, warning Vuetify)
  statusIdle:    '#5F6B7A',  // L52 C0.03 H230 — info pasiva (sismo, presa)

  // ========== LABELS (contraste AA para texto pequeño) ==========

  // Labels/encabezados pequeños (10-11px, mayúsculas con tracking) sobre
  // bg-surface/bg-card. textDim (#64708B en vibrante) da 2.94:1 sobre
  // bg-surface — reprueba WCAG AA (4.5:1). Este token garantiza ≥5.6:1 en
  // los fondos oscuros del sistema. Los temas CLAROS deben sobreescribirlo
  // (diurno.js lo hace). Origen: auditoría UX portal de terceros 2026-07-12.
  textLabel:     '#8FA3C2',  // 5.67:1 sobre #122A45, 7.56:1 sobre #040E1A

  // ========== ALERT (5 slots de feedback de sistema) ==========

  alertSos:     '#E84A3D',             // L65 C0.22 H18  — SOS ciudadano (máximo grito)
  alertDanger:  '#BA4D3D',             // L55 C0.17 H25  — error UI
  alertWarning: '#D6A73A',             // L72 C0.15 H80  — precaución UI
  alertSuccess: '#3DA568',             // L58 C0.14 H145 — confirmación UI (separado ya de accent/online)
  alertInfo:    '#5DA5E0',             // L68 C0.13 H215 — info UI
  alertSosSoft: 'rgba(232, 74, 61, 0.22)', // derivado — fondos de SOS banners

  // ========== KPI (4 categorías semánticas fijas) ==========

  kpiSeguridad: '#4687D4',  // = entityBlue (misma semántica)
  kpiMedico:    '#DB4577',  // L62 C0.22 H355 — rosa-magenta médico
  kpiPcivil:    '#D9A348',  // L70 C0.17 H65  — protección civil
  kpiPublico:   '#40B8BA',  // L68 C0.14 H182 — servicios públicos
}
